/**
 * PostHog capture. Pass the client from usePostHog() so call sites
 * work when PostHog is disabled (client is undefined).
 * Use capture(posthog, eventName, properties) throughout the app for easier search/review.
 */

const envPosthogKey = process.env.REACT_APP_PUBLIC_POSTHOG_KEY;

/** Set when REACT_APP_PUBLIC_POSTHOG_KEY is non-empty (provider mounts in index.tsx). */
export const posthogApiKey =
  typeof envPosthogKey === "string" && envPosthogKey.length > 0
    ? envPosthogKey
    : undefined;

/** True when REACT_APP_PUBLIC_POSTHOG_KEY is set (provider mounts in index.tsx). */
export const posthogEnabled = posthogApiKey !== undefined;

export type PostHogClient =
  | { capture: (event: string, properties?: Record<string, unknown>) => void }
  | undefined;

export function capture(
  posthog: PostHogClient,
  eventName: string,
  properties?: Record<string, unknown>
) {
  if (!posthogEnabled) {
    if (process.env.NODE_ENV === "development") {
      console.log("[PostHog capture]", eventName, properties ?? {});
    }
    return;
  }
  if (posthog) {
    posthog.capture(eventName, properties);
  }
}
